import * as yup from 'yup';
import { newPasswordSchema } from '../../auth';
import { INVALID_EMAIL_MSG } from '../../validation';

const emailSchema = yup.object().shape({
  email: yup
    .string()
    .trim()
    .required('Email is required')
    .email(INVALID_EMAIL_MSG),
});

export const schema = newPasswordSchema.concat(emailSchema);
